import {useState, createRef} from "react";
import DataGrid, {
    Column,
    Editing,
    Pager,
    Paging,
    Export,
    SearchPanel,
    Sorting,
} from "devextreme-react/data-grid";
import ExcelJS from "exceljs";
import {exportDataGrid} from "devextreme/excel_exporter";
import format from "date-fns/format";
import autoTable from 'jspdf-autotable'
import saveAs from 'file-saver';
import {FormContainer} from "../../../../palette/Palette";
import {jsPDF} from "jspdf";
import {exportDataGrid as exportDataGridToPdf} from "devextreme/pdf_exporter";
import {db} from "../../../../firebase/Firebase";
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import {useSnackbar} from "notistack";
import VerticalSpace from "../../../../palette/VerticalSpace";
import axios from "axios";
import HeaderPage from "../../../../palette/HeaderPage";
import ComponentLoadPanel from "../../../../palette/LoadPanel";
import add from 'date-fns/add'
import {useHistory} from 'react-router-dom';

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
}


//const url = 'http://127.0.0.1:5000/check-delete-passengers';
const url = 'https://check-delete-passengers-easi4xatjq-uc.a.run.app/check-delete-passengers';
const urlDeleteUser = 'https://update-delete-users-easi4xatjq-uc.a.run.app/delete-users';

const now = new Date();

function PassengersManagementsGrid(props) {

    const {
        dataSource, setVisibleForm, setVisibleGrid, setDataEdit, setEdit, DataStore, setTrigger, trigger, load,
        setReservationManual, setDataPassengers, setParcels, setExpress
    } = props

    const {companyName, idCompany, triggerEffect} = DataStore

    const [showPanel, setShowPanel] = useState(false);
    const [textPanel, setTextPanel] = useState('Verificando viajes. . .');

    const dataGridRef = createRef();
    const {enqueueSnackbar} = useSnackbar();
    let history = useHistory();

    const onExporting = (e) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');

        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
            autoFilterEnabled: true,
            topLeftCell: {row: 6, column: 2},
            customizeCell: ({gridCell, excelCell}) => {

                if (gridCell.rowType === 'data') {
                    if (excelCell.row % 2 === 0) {
                        excelCell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: {argb: 'C6EFCE'},
                            bgColor: {argb: 'C6EFCE'}
                        };
                    }
                }
            }
        }).then(function () {

            const headerCompany = worksheet.getRow(2);
            const headerReport = worksheet.getRow(3);
            const headerDate = worksheet.getRow(4);

            headerCompany.getCell(2).value = companyName;
            headerCompany.getCell(2).font = {bold: true, size: 16, underline: 'double'};

            headerReport.getCell(2).value = `Reporte : Lista de pasajeros`;
            headerReport.getCell(2).font = {name: 'Segoe UI Light', size: 12, bold: 600};
            headerReport.getCell(2).alignment = {horizontal: 'left'}

            headerDate.getCell(2).value = `Fecha : ${format(new Date(), 'yyyy-MM-dd')}`;
            headerDate.getCell(2).font = {name: 'Segoe UI Light', size: 8, bold: 700};
            headerDate.getCell(2).alignment = {horizontal: 'left'}

            workbook.xlsx.writeBuffer().then(function (buffer) {
                saveAs(new Blob([buffer], {type: 'application/octet-stream'}), 'Lista-pasajeros.xlsx');
            });
        });
        e.cancel = true;
    }

    const onToolbarPreparing = (e) => {

        const {toolbarOptions} = e
        const {items} = toolbarOptions

        items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                width: 120,
                text: 'Imprimir',
                elementAttr: {id: 'btn-pdf'},
                icon: 'far fa-file-pdf',
                onClick: exportGridPDF
            }
        })

        items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Crear nuevo',
                elementAttr: {id: 'button-add-grid'},
                icon: 'fas fa-plus-circle',
                onClick: () => {
                    setVisibleForm(true)
                    setEdit(false)
                    setVisibleGrid(false)
                }
            }
        })
    }

    function exportGridPDF() {
        const pdfDoc = new jsPDF();
        const dataGrid = dataGridRef.current.instance;

        const options = {
            jsPDFDocument: pdfDoc,
            component: dataGrid,
            autoTableOptions: {
                margin: {top: 35, left: 15}
            },
        }

        exportDataGridToPdf(options).then(() => {
            pdfDoc.setFontSize(12);
            const pageCount = pdfDoc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                pdfDoc.setPage(i);
                const pageSize = pdfDoc.internal.pageSize;
                const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
                const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                const header = companyName;
                const report = `Reporte : Lista de pasajeros`
                const date = `Fecha : ${format(new Date(), 'yyyy-MM-dd')}`
                const footer = `Pagina ${i} de ${pageCount}`;

                // Header
                pdfDoc.setFontSize(14)
                pdfDoc.setFont('helvetica', '', 'bold')
                pdfDoc.text(header, 15, 10, {baseline: 'top'});
                pdfDoc.setFontSize(12)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(report, 15, 17, {baseline: 'top'});
                pdfDoc.setFontSize(8)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(date, 15, 22, {baseline: 'top'});
                // Footer
                pdfDoc.setFontSize(8)
                pdfDoc.text(footer, pageWidth / 2 - (pdfDoc.getTextWidth(footer) / 2), pageHeight - 15, {baseline: 'bottom'});

            }
        }).then(() => {
            pdfDoc.save('Lista-pasajeros.pdf');
        });
    }

    const onRowUpdating = (e) => {
        setDataEdit(e.row.data)
        setVisibleForm(false)
        setEdit(true)
        setVisibleGrid(false)
        setReservationManual(false)
    }

    const onRowRemoved = async (e) => {
        const docId = e.data.docId;
        const addYear = add(now, {years: 1})

        const data = {
            companyName: companyName,
            idCompany: idCompany,
            passenger: `${e.data.name} ${e.data.lastName}`,
            date: format(now, 'yyyy-MM-dd'),
            startYear: format(now, 'yyyy'),
            endYear: format(addYear, 'yyyy')
        }
        setShowPanel(true)
        setTimeout(() => setTextPanel('Espere un momento . . .'), 4000)

        await axios.post(url, data, {headers: headers})
            .then(async res => {
                if (res.data.result === 'OK') {
                    await db.collection(companyName).doc(idCompany).collection('PassengersManagement').doc(docId)
                        .delete().then(async () => {
                            await axios.post(urlDeleteUser, {uid: docId}, {headers: headers})
                                .then(res => {
                                    if (res.data) {
                                        setShowPanel(false)
                                        NotiStackInfo('Pasajero eliminado exitosamente', 'success',
                                            enqueueSnackbar)
                                        setTextPanel('Verificando viajes. . .')
                                    } else {
                                        setShowPanel(false)
                                        NotiStackInfo('Pasajero eliminado exitosamente', 'success',
                                            enqueueSnackbar)
                                        setTextPanel('Verificando viajes. . .')
                                    }
                                })
                        }).catch(() => {
                            NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                            setTrigger(!trigger);
                        })
                } else {
                    setShowPanel(false)
                    setTextPanel('Verificando viajes. . .')
                    NotiStackInfo('El pasajero mantiene viajes pendientes, aun no puede ser eliminado!', 'warning',
                        enqueueSnackbar)
                    setTrigger(!trigger)
                }
            }).catch(() => {
                setShowPanel(false)
                setTextPanel('Verificando viajes. . .')
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                setTrigger(!trigger)
            })
    };

    const onManualReservation = (e) => {
        setDataPassengers(e.row.data);
        setVisibleForm(false)
        setEdit(false)
        setVisibleGrid(false)
        setReservationManual(true)
        setParcels(false)
    }
    const parcels = (e) => {
        setDataPassengers(e.row.data);
        setParcels(true)
        setVisibleForm(false)
        setEdit(false)
        setVisibleGrid(false)
        setReservationManual(false)

    }
    const express = (e) => {
        DataStore.getTriggerEffect(!triggerEffect)
        DataStore.getDataPassengers(e.row.data);
        history.push('/control-panel/express');
    }

    const buttons = [
        {
            hint: 'Editar',
            icon: 'fas fa-pencil-alt',
            visible: true,
            onClick: onRowUpdating,
        },
        'delete'];

    const buttonsTrips = [
        {
            hint: 'Reserva manual',
            icon: 'fas fa-taxi',
            visible: true,
            onClick: onManualReservation,
        },
        {
            hint: 'Encomiendas',
            icon: 'fas fa-shipping-fast',
            visible: true,
            onClick: parcels,
        },
        {
            hint: 'Viaje express',
            icon: 'fas fa-road',
            visible: true,
            onClick: express,
        },


    ]

    return (
        <>
            <VerticalSpace space={30}/>
            <div className="grid-container">
                <HeaderPage icon={'fas fa-user-tie'} text={'Gestión de pasajeros'} load={load}
                            textLoad={'Cargando...'}/>
                <FormContainer>
                    <DataGrid
                        id="types-vehicles"
                        ref={dataGridRef}
                        dataSource={dataSource}
                        keyExpr="ID"
                        allowColumnReordering={true}
                        showBorders={true}
                        onToolbarPreparing={onToolbarPreparing}
                        onRowRemoved={onRowRemoved}
                        rowAlternationEnabled={true}
                        noDataText={'Esperando datos'}
                        onExporting={onExporting}
                    >
                        <SearchPanel visible={true}
                                     width={240}
                                     placeholder="Buscar"/>
                        <Export enabled={true} texts={{exportAll: 'Excel'}}/>
                        <Sorting mode="multiple"/>
                        <Paging defaultPageSize={20}/>
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={[10, 20, 30]}
                            showInfo={true}/>
                        <Editing
                            mode="row"
                            texts={{
                                editRow: 'Editar',
                                deleteRow: 'Eliminar pasajero',
                            }}
                            useIcons={true}
                            allowUpdating={true}
                            allowDeleting={true}
                        />
                        <Column dataField="name" alignment={'center'} caption={'Nombres'}/>
                        <Column dataField="lastName" alignment={'center'} caption={'Apellidos'}/>
                        <Column dataField="contactNumber" alignment={'center'} caption={'Núm. de contacto'}/>
                        <Column dataField="city" alignment={'center'} caption={'Ciudad'}/>
                        <Column dataField="birthdate" alignment={'center'} caption={'Fecha de nacimiento'}/>
                        <Column dataField="state" alignment={'center'} caption={'Estado'}/>
                        <Column type="buttons" width={120} buttons={buttonsTrips} caption={'Reserva'}/>
                        <Column type="buttons" width={100} buttons={buttons}/>

                    </DataGrid>
                </FormContainer>
                <ComponentLoadPanel showLoadPanel={showPanel} messages={textPanel}/>
            </div>
        </>
    )
}


export default PassengersManagementsGrid